// Recovered compiled webpack factory 88280. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { C: () => c, x: () => u });
  var a = r(95155),
    n = r(67909),
    l = r(12115),
    s = r(47850),
    i = r(87577),
    d = r(82984);
  let o = (0, n.default)(
    () =>
      Promise.all([r.e(3432), r.e(7383)])
        .then(r.bind(r, 87383))
        .then((e) => e.LiquidMetal),
    { loadableGenerated: { webpack: () => [87383] }, ssr: !1 },
  );
  function c(e) {
    let { children: t, className: r = "", surface: n = "default" } = e,
      [c, f] = (0, l.useState)(1),
      [m, p] = (0, l.useState)(null),
      x = (0, l.useRef)(null),
      h = (0, i.q)(x);
    return (
      (0, l.useEffect)(() => {
        (f(+!window.matchMedia("(prefers-reduced-motion: reduce)").matches), p((0, d.u)()));
      }, []),
      (0, a.jsxs)("div", {
        ref: x,
        className: "relative h-full p-[6px]",
        children: [
          (0, a.jsx)("div", {
            className: "absolute inset-0 overflow-hidden squircle-lg",
            children:
              m && h
                ? (0, a.jsx)(s.E, {
                    className: "h-full w-full",
                    children: (0, a.jsx)(o, {
                      shape: "none",
                      fit: "cover",
                      scale: 1,
                      colorBack: "#9a9a9d",
                      colorTint: "#ffffff",
                      repetition: 2.4,
                      softness: 0.1,
                      shiftRed: 0.3,
                      shiftBlue: 0.3,
                      distortion: 0.1,
                      contour: 0.4,
                      angle: 70,
                      speed: c,
                      width: "100%",
                      height: "100%",
                      style: { width: "100%", height: "100%" },
                    }),
                  })
                : (0, a.jsx)(u, { animate: 0 !== c }),
          }),
          (0, a.jsx)("div", {
            className: `relative h-full squircle-md shadow-[0_20px_50px_-25px_rgba(0,0,0,0.45)] ${"graphite" === n ? "bg-[#141416]" : "bg-white dark:bg-[#0c0c0e]"} ${r}`,
            children: t,
          }),
        ],
      })
    );
  }
  function u(e) {
    let { animate: t } = e;
    return (0, a.jsxs)("div", {
      className: "absolute inset-0 bg-[#b9b9bd]",
      children: [
        (0, a.jsx)("div", {
          className: `absolute left-1/2 top-1/2 aspect-square w-[170%] -translate-x-1/2 -translate-y-1/2 ${t ? "um-metal-spin" : ""}`,
          style: {
            background:
              "conic-gradient(from 0deg, #7f7f83, #ffffff, #b9b9be, #6f6f73, #fbfbfc, #9a9a9e, #7f7f83)",
          },
        }),
        (0, a.jsx)("div", {
          className: "absolute inset-0",
          style: {
            background:
              "radial-gradient(120% 80% at 30% 15%, rgba(255,255,255,0.55), transparent 55%)",
          },
        }),
      ],
    });
  }
}
